/**
 * Admin Layout
 * 관리자 페이지 레이아웃 (Sidebar + Content)
 */

import React, { useState, useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useAdminAuth } from '../../use-cases';
import { AdminSidebar } from './AdminSidebar';
import { useUserStore } from '../../../../store/userStore';

export const AdminLayout: React.FC = () => {
  const navigate = useNavigate();
  const { logout } = useAdminAuth();
  // userStore에서 currentUser 가져오기 (AdminAuthService가 여기에 저장함)
  const user = useUserStore((state) => state.currentUser);
  const [sidebarOpen, setSidebarOpen] = useState(true);


  // User 타입을 AdminUser 타입으로 변환
  const currentUser = user ? {
    id: user.id,
    email: user.email || '',
    name: user.name || '',
    role: (user.role === 'admin' ? 'super_admin' : user.role) as 'super_admin' | 'operator',
    phone: user.phone,
    service_type: (user as any).service_type,
    is_active: true,
    is_suspended: false,
    created_at: (user as any).created_at || new Date().toISOString(),
    updated_at: (user as any).updated_at || new Date().toISOString(),
  } : null;

  useEffect(() => {
    if (!currentUser) {
      navigate('/admin/login');
    }
  }, [currentUser, navigate]);

  const handleLogout = async () => {
    const confirmed = window.confirm('로그아웃 하시겠습니까?');
    if (confirmed) {
      await logout();
      window.location.href = 'https://newattend.com';
    }
  };

  if (!currentUser) {
    return null;
  }

  return (
    <div className="min-h-screen bg-gray-100">
      {/* Top Navigation Bar */}
      <nav className="bg-white shadow-sm border-b border-gray-200 fixed top-0 left-0 right-0 z-10">
        <div className="w-full px-4 h-16 flex items-center justify-between">
          {/* Left: Logo & Menu Toggle */}
          <div className="flex items-center space-x-4">
            <button
              onClick={() => setSidebarOpen(!sidebarOpen)}
              className="p-2 rounded-md hover:bg-gray-100"
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 6h16M4 12h16M4 18h16"
                />
              </svg>
            </button>
            <h1 className="text-xl font-bold text-gray-900">
              NewAttend Admin
            </h1>
          </div>

          {/* Right: User Info & Logout */}
          <div className="flex items-center space-x-4">
            <div className="text-right hidden md:block">
              <p className="text-sm font-medium text-gray-900">
                {currentUser.name}
              </p>
              <p className="text-xs text-gray-500">{currentUser.email}</p>
            </div>
            <button
              onClick={handleLogout}
              className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 text-sm whitespace-nowrap"
            >
              로그아웃
            </button>
          </div>
        </div>
      </nav>

      {/* Layout Container */}
      <div className="pt-16 flex">
        {/* Sidebar */}
        <AdminSidebar isOpen={sidebarOpen} currentUser={currentUser} />

        {/* Main Content */}
        <main
          className={`flex-1 p-6 transition-all duration-300 ${
            sidebarOpen ? 'ml-64' : 'ml-0'
          }`}
        >
          <Outlet />
        </main>
      </div>
    </div>
  );
};
